import classNames from 'classnames';
import { Heading } from 'components/1-atoms/Heading';
import { Container, ContainerWidth } from 'components/4-habitats/Container';
import { TopArea, TopAreaProps } from 'components/4-habitats/TopArea';
import styles from './SearchPage.module.scss';

interface SearchPageProps {
	heading: string;
	searchText: string;
	pageWidth?: ContainerWidth;
	topBanner?: React.ReactNode;
	additionalTop?: TopAreaProps['additional'];
	additionalPageContent?: React.ReactNode;
}
export const SearchPage: React.FC<SearchPageProps> = ({
	heading,
	searchText,
	topBanner,
	pageWidth = 'Medium',
	additionalTop,
	additionalPageContent,
}) => {
	return (
		<div className={styles.SearchPage}>
			<TopArea additional={{ top: additionalTop?.top }} topBanner={topBanner} />
			{additionalPageContent}
			{additionalTop?.bottom && (
				<Container className={styles.ContentPage_topWrapper} width={pageWidth} padded>
					{additionalTop.bottom}
				</Container>
			)}
			<Container
				width={pageWidth}
				className={classNames(
					styles.SearchPage_container,
					(additionalPageContent || additionalTop?.bottom) && styles.SearchPage_container___noTopMargin,
				)}
			>
				<Heading className={styles.SearchPage_heading} headingLevel="h1" style="xl">
					{heading}
				</Heading>
				<div id="cludo-search-results" className="cludo-search-results">
					<div id="cludo-search-content-inline">
						<div className="modal-body skts-search-modal" id="cludo-search-content-form2">
							<div className="input-group" id="siteSearchWrapperInline">
								<label className="sr-only" htmlFor="siteSearchInline">
									{searchText}
								</label>
								<input type="search" id="siteSearchInline" className="form-control" placeholder={searchText} autoComplete="off" />
								<span className="input-group-btn">
									<button
										id="siteSearchButtonInline"
										className="btn skts-icon skts-icon--soeg-hvid skts-icon--large"
										type="button"
										data-stat="cludo search"
									>
										<span className="input-group-btn">
											<span className="sr-only">{searchText}</span>
										</span>
									</button>
								</span>
							</div>
						</div>
					</div>
					<div className="cludo-search-results__facets search-filters" aria-controls="search-results"></div>
					<div className="cludo-search-results__search-result-count search-result-count" role="status"></div>
					<div className="cludo-search-results__did-you-mean search-did-you-mean"></div>
					<div
						className="cludo-search-results__results search-results"
						role="region"
						id="search-results"
						aria-live="polite"
						aria-label="Search results"
					></div>
				</div>
			</Container>
		</div>
	);
};
